import { useListServicesForAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

export interface ServiceOption {
  label: string;
  value: string;
}

const useListServicesForAccount = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null;

  const { data, error, isLoading, refetch, isFetching } =
    useListServicesForAccountQuery({
      slug: accountSlug,
      page: { number: 1, size: 500 },
    });

  let services: ServiceOption[] = [];

  if (data?.data) {
    try {
      services = data.data
        .filter((s) => s.id && s.attributes?.name)
        .map((s) => ({
          value: String(s.id),
          label: s.attributes.name,
        }));
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    services,
    servicesLoading: isLoading,
    servicesFetching: isFetching,
    error: error ?? customError,
    refetch,
  };
};

export default useListServicesForAccount;
